.dangerZone {
  border: 1px solid #f5c6c5;
  border-radius: var(--radius);
  padding: 20px 22px;
  background: #fffafa;
}

.deleteSection {
  border-top: 1px solid #f5c6c5;
  padding-top: 18px;
  margin-top: 4px;
}

.deleteRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.deleteInfo { flex: 1; }

.deleteLabel {
  font-size: 15px;
  font-weight: 600;
  color: var(--red);
}

.deleteHint {
  font-size: 13.5px;
  color: var(--muted);
  margin-top: 3px;
  line-height: 1.5;
}

.deleteBtn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 16px;
  background: none;
  color: var(--red);
  border: 1.5px solid var(--red);
  border-radius: 24px;
  font-size: 13.5px;
  font-weight: 600;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  white-space: nowrap;
  transition: background .15s, color .15s;
  flex-shrink: 0;
}

.deleteBtn:hover {
  background: var(--red-lt);
}

.confirmBox {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.confirmText {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  color: var(--ink2);
  line-height: 1.5;
}

.confirmActions {
  display: flex;
  gap: 10px;
}

.cancelBtn {
  display: inline-flex;
  align-items: center;
  padding: 7px 18px;
  background: white;
  color: var(--muted);
  border: 1.5px solid var(--border);
  border-radius: 24px;
  font-size: 13.5px;
  font-weight: 500;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  transition: border-color .15s, color .15s;
}

.cancelBtn:hover { border-color: #bdc1c6; color: var(--ink); }
.cancelBtn:disabled { opacity: .5; cursor: default; }

.confirmDeleteBtn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 18px;
  background: var(--red);
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 13.5px;
  font-weight: 600;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  transition: background .15s;
}

.confirmDeleteBtn:hover:not(:disabled) { background: #a81b18; }
.confirmDeleteBtn:disabled { opacity: .5; cursor: default; }

.deleteError {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13.5px;
  color: var(--red);
}
